import * as actions from './actions'
import produce from 'immer'

const initialState = {
  privacy: false,
  userPermissions: null,
}

export const reducer = produce((state, action) => {
  switch (action.type) {
    case actions.SET_PRIVACY:
      state.privacy = action.payload.privacy
      break
    case actions.SET_USER_PERMISSIONS:
      state.userPermissions = action.payload.permissions
      break
    default:
      break
  }
}, initialState)
